import React from 'react';
import { Modal } from 'react-bootstrap';
import './ConfirmModal.scss';

const ConfirmModal = ({
  onCancel,
  onConfirm,
  children,
}) => (
  <Modal
    show
    centered
    enforceFocus={false}
    size="lg"
    onHide={onCancel}
    dialogClassName="confirm-modal"
  >
    <Modal.Body>
      <div className="confirm-modal-body">

        <div className='d-flex justify-content-between w-100'>
          <span>DELETE EMPLOYEE</span>
          <i className='zwicon-close' onClick={onCancel} />
        </div>

        <div className="caution-logo">
          <img src="img/caution.svg" alt="" />
        </div>
        <div className="confirm-modal-content">
          {children}
        </div>

        <div className="d-flex justify-content-end w-100">
          <i className='zwicon-checkmark' onClick={onConfirm}/>
        </div>
      </div>
    </Modal.Body>
  </Modal>
);

export default ConfirmModal;
